@switch (type) {
  @case ('text') {
    @if (accountId && accountId === CARRY_FORWARD_ACCOUNT_ID) {
      Default
    } @else {
      @if (account()) {
        {{ account()?.name }}
        @if (account()?.permanentTags?.list) {
          <br />
          @for (tag of account()?.permanentTags?.list; track tag) {
            <app-permanent-tag-card
              [small]="true"
              [tagId]="tag"
              [type]="'text'"></app-permanent-tag-card>
          }
        }
        @if (currentUser$ | async; as currentUser) {
          @if (owner?.id !== currentUser?.id) {
            <app-user-card
              [user]="{
                id: owner?.id,
                userType: owner?.type,
              }"
              [small]="true"></app-user-card>
          }
        }
      } @else if (accountUnavailable()) {
        Account unavailable
      } @else {
        <div class="skeleton h-4 w-32"></div>
      }
    }
  }

  @case ('card') {
    @if (account() || (accountId && accountId === CARRY_FORWARD_ACCOUNT_ID)) {
      <div class="flex items-center space-x-3">
        <!-- @if (account.profileImage) {
            <div class="avatar">
              <div class="mask mask-circle w-8 h-8">
                <img [src]="account.profileImage" alt="" />
              </div>
            </div>
          } @else {
            <div class="flex justify-center items-center w-8 h-8">
              <fa-icon [icon]="faUser"></fa-icon>
            </div>
          } -->
        <div>
          <div class="font-bold mb-2">
            @if (accountId && accountId === CARRY_FORWARD_ACCOUNT_ID) {
              Default
            } @else {
              {{ account()?.name }}
            }
          </div>
          @if (account()?.permanentTags?.list) {
            <div class="flex flex-wrap gap-2">
              @for (tag of account()?.permanentTags?.list; track tag) {
                <app-permanent-tag-card
                  [small]="true"
                  [tagId]="tag"></app-permanent-tag-card>
              }
            </div>
          }
          @if (currentUser$ | async; as currentUser) {
            @if (owner?.id !== currentUser?.id) {
              <app-user-card
                [userId]="owner?.id"
                [userType]="owner?.type"
                [user]="{
                  id: owner?.id,
                  userType: owner?.type,
                }"
                [small]="true"></app-user-card>
            }
          }
        </div>
      </div>
    } @else if (accountUnavailable()) {
      Account unavailable
    } @else {
      <!-- {{ userId }} -->
      <div class="flex items-center space-x-3">
        <!-- <div class="avatar">
            <div class="rounded-box w-12 h-12">
              <div class="skeleton w-12 h-12 rounded-none"></div>
            </div>
          </div> -->
        <div>
          <div class="skeleton h-4 w-32"></div>
        </div>
      </div>
    }
  }
}
